// extracted by mini-css-extract-plugin
export var banner = "Header-module--banner--fe5c2";
export var bottom = "Header-module--bottom--2b837";
export var container = "Header-module--container--d1b7f";
export var desktop = "Header-module--desktop--2f0ad";
export var header = "Header-module--header--357cc";
export var logo = "Header-module--logo--edb3a";
export var logoDesktop = "Header-module--logo-desktop--2b595";
export var logoMobile = "Header-module--logo-mobile--c35b3";
export var menu = "Header-module--menu--8c2df";
export var mobile = "Header-module--mobile--fcad9";
export var salesNumber = "Header-module--sales-number--49dde";
export var top = "Header-module--top--1010e";
export var topContainer = "Header-module--top-container--cb211";